'use strict';

var SvgIcon$1 = require('./SvgIcon.js');



module.exports = SvgIcon$1["default"];
